import React, { useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import usa from "../FInput/images/usa.png";
import colombia from "../FInput/images/colombia.png";
import styles from "./style/FInput.module.scss";

const FInput = ({
  type = "text",
  title = "Titulo",
  name = "",
  maxLength = 100,
  placeholder = "placeholder",
  onChange = () => {},
  errors = "",
  value = null,
  options = [],
  selectedOption = "",
  border = "",
  onKeyDown = () => {},
  disabled = true,
  className = null,
}) => {
  const FSelectIcon = {
    control: (base, state) => ({
      ...base,
      // background: "#e3e0dd",
      height: "45px",
      margin: "10px 0px",
      border: "0px",
      fontWeight: "bolder",
      backgroundColor: "#f6f6f6",
      borderRadius: "10px",
    }),
  };

  const dataIconPhone = [
    // {
    //   value: "484",
    //   text: "México",
    //   iso: "MX",
    // },
    // {
    //   value: "840",
    //   text: "Estados Unidos",
    //   iso: "US",
    // },
  ];

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const [native, setNative] = useState("");
  const onNativeChange = (e) => {
    onChange(e.target.value);
    setNative(e.target.value);
  };

  switch (type) {
    case "SelectIcon":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <Select
            isSearchable={false}
            styles={FSelectIcon}
            placeholder={placeholder}
            value={options[value]}
            options={options.length == 0 ? dataIconPhone : options}
            onChange={onChange}
            getOptionLabel={(e) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={require(`../FInput/images/${e.iso}.png`)}
                  style={{ height: "20px" }}
                />
                <span style={{ marginLeft: 5 }}>{e.text}</span>
              </div>
            )}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );
    case "Select":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <Select
            isSearchable={false}
            styles={FSelectIcon}
            placeholder={placeholder}
            value={selectedOption}
            options={options.length == 0 ? dataIconPhone : options}
            onChange={onChange}
            getOptionLabel={(e) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginLeft: 5 }}>{e.text}</span>
              </div>
            )}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );
    case "DatePicker":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <input
            type="date"
            value={native}
            className={classNames(
              styles.FDatePicker,
              !!errors ? "border-2" : "border-0",
              "border-red-500"
            )}
            onChange={onNativeChange}
          />
        </div>
      );
    case "botton":
      return (
        <button
          className={
            className == null
              ? "bg-primary px-4 w-full py-1 rounded-xl text-white hover:shadow-lg hover:shadow-primary/50"
              : className
          }
          onClick={onChange}
        >
          {title}
        </button>
      );
    case "submit":
      return (
        <button
          disabled={!disabled}
          type={type}
          className={
            disabled
              ? "bg-primary px-4 w-full py-1 rounded-xl text-white hover:shadow-lg hover:shadow-primary/50"
              : "bg-gray-300 px-4 w-full py-1 rounded-xl text-white"
          }
        >
          {title}
        </button>
      );
    case "password":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <input
            type={type}
            name={name}
            className={classNames(
              styles.FInputText,
              !!errors ? "border-2" : "border-0",
              "border-red-500"
            )}
            placeholder={placeholder}
            onChange={onChange}
          />
          <p className="text-red-500 font-bold w-64">{errors}</p>
        </div>
      );
    case "text":
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <input
            type={type}
            name={name}
            maxLength={maxLength}
            className="bg-backgroundInput w-full h-[63px] rounded-[12px] pl-4"
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onKeyUp={onKeyDown}
          />
          <p className="text-red-500 font-bold w-64">{errors}</p>
        </div>
      );
    default:
      return (
        <div className={styles.FButtonDiv}>
          <div className={styles.FInputTitle}>{title}</div>
          <input
            type={type}
            name={name}
            maxLength={maxLength}
            className={classNames(
              styles.FInputText,
              !!errors ? "border-2" : "border-0",
              "border-red-500"
            )}
            value={value}
            style={{ border: border }}
            placeholder={placeholder}
            onChange={onChange}
            onKeyUp={onKeyDown}
          />
          <p className="text-red-500 font-bold">{errors}</p>
        </div>
      );
  }
};

export default FInput;
